// extracted by mini-css-extract-plugin
module.exports = {"content":"content___37Ejb","textOverlay":"textOverlay___3k1kv","title":"title___3IfTp","desc":"desc___1Mkby"};